import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { ZIndex } from "src/ui/constants";

export const TriggerThumbnail = styled.img``;
export const TriggerLabel = styled.span``;
export const ArrowIcon = styled.span``;
export const FieldLabel = styled.div``;
export const OosLabel = styled.span``;

export const OptionThumbnail = styled.img``;
export const OptionLabel = styled.span``;
export const SelectedIcon = styled.span``;

export const Trigger = styled.button`
	${({ theme }) => css`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: ${theme.dimensions.margin.small};
		width: 100%;
		padding: ${theme.dimensions.margin.xSmall} ${theme.dimensions.margin.small};
		background: transparent;
		border: 1px solid ${theme.colors.backgrounds[3].background};
		border-radius: ${theme.dimensions.borderRadius};
		cursor: pointer;
		font-family: ${theme.typography.fontFamily.primary};
		font-weight: 300;
		font-size: ${theme.typography.fontSize.base};
		color: ${theme.colors.foregrounds[3]};
		transition: border-color 0.15s ease;

		&:hover {
			border-color: ${theme.colors.foregrounds[5]};
		}

		&[data-oos] {
			border-color: #c67a00;
		}

		${OosLabel} {
			font-size: ${theme.typography.fontSize.xSmall};
			color: #c67a00;
			white-space: nowrap;
		}

		${TriggerThumbnail} {
			width: 48px;
			height: 48px;
			object-fit: cover;
			border-radius: 2px;
			flex-shrink: 0;
		}

		${TriggerLabel} {
			flex: 1;
			text-align: left;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		${ArrowIcon} {
			flex-shrink: 0;
			font-size: ${theme.typography.fontSize.small};
			transition: transform 0.15s ease;
		}
	`}
`;

export const Option = styled.div`
	${({ theme }) => css`
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: ${theme.dimensions.margin.small};
		padding: ${theme.dimensions.margin.xSmall} ${theme.dimensions.margin.small};
		cursor: pointer;
		font-family: ${theme.typography.fontFamily.primary};
		font-weight: 300;
		font-size: ${theme.typography.fontSize.base};
		color: ${theme.colors.foregrounds[3]};
		transition: background-color 0.1s ease;

		&:hover {
			background-color: ${theme.colors.backgrounds[3].background};
		}

		&[data-selected="true"] {
			background-color: ${theme.colors.backgrounds[3].background};
		}

		${OptionThumbnail} {
			width: 48px;
			height: 48px;
			object-fit: cover;
			border-radius: 2px;
			flex-shrink: 0;
		}

		${OptionLabel} {
			flex: 1;
			overflow: hidden;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		${SelectedIcon} {
			flex-shrink: 0;
			font-size: ${theme.typography.fontSize.large};
			opacity: 0;

			&[data-visible="true"] {
				opacity: 1;
			}
		}
	`}
`;

export const OptionList = styled.div`
	${({ theme }) => css`
		position: fixed;
		z-index: ${ZIndex.Dropdown};
		background: ${theme.colors.backgrounds[2].background};
		border: 1px solid ${theme.colors.backgrounds[3].background};
		border-radius: ${theme.dimensions.borderRadius};
		box-shadow: ${theme.app.shadows.dropdown};
		max-height: 300px;
		overflow-y: auto;
		padding: ${theme.dimensions.margin.xxSmall} 0;
	`}
`;

export const Root = styled.div`
	${({ theme }) => css`
		position: relative;
		margin: 0 0 ${theme.dimensions.margin.small} 0;

		${FieldLabel} {
			font-family: ${theme.typography.fontFamily.secondary};
			font-weight: ${theme.typography.fontWeight.light};
			font-size: ${theme.typography.fontSize.xLarge};
			color: ${theme.colors.foregrounds[0]};
			margin-bottom: ${theme.dimensions.margin.small};
		}
	`}
`;
